module.exports = __webpack_public_path__ + "img/chinese_3.e8bb50d5.png";